export default __webpack_public_path__ + "locales/es/PaymentsEnterprise.json?hash=35086f4c56ba2214bbc522850b936ff8";